// extracted by mini-css-extract-plugin
export default {"App":"App_App__1dpsw","label":"App_label__3ePzp","fullWidthHeight":"App_fullWidthHeight__rqeay"};